import { isPlatformBrowser } from '@angular/common'
import {  ChangeDetectorRef, Component, DestroyRef, Inject, Input, OnChanges, OnInit, PLATFORM_ID, SimpleChanges, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { Partner } from '@app/models/partner/IPartner';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
interface Item {
    code: string;
    name: string;
}
@Component({
    selector: 'clever-touroperator',
    templateUrl: './touroperator.component.html',
    styleUrls: ['./touroperator.component.scss'],
    standalone: false
})
export class TouroperatorComponent implements OnInit, OnChanges {
    @Input() mode: string;
    @Input() tourOperatorList: any [];
    @Input() partner: Partner;
    isBrowser: boolean = false;
    slicenbr: number = 5;
    destroyRef = inject(DestroyRef);
    selectedList: string[] = [];
    tourOperatorListAll: any [];
    tourOperatorListAEx: any [];
    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected hotelService: HotelFiltersService,
        protected cdr: ChangeDetectorRef
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.checktypes(this.partner?.agenturen);
            this.initFilterSub();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['tourOperatorList']) {
            this.checktypesEx(changes['tourOperatorList'].currentValue);
        }
    }

    sortArray(array): any[] {
        if (array?.length > 0) {
            array?.sort((a, b) => {
                a = a.name.toLowerCase();
                b = b.name.toLowerCase();

                return a < b ? -1 : a > b ? 1 : 0;
            });
        }
        return array;
    }

    showMore(all) {
        this.slicenbr = all;
    }

    checktypesEx(array) {
        for (let i = 0; i < array?.length; i++) {
            if(this.partner?.filters?.['hideVeranstalter' + array[i].code + 'filter']) {
                array.splice(i, 1);
                i--;
            }
        }

        this.tourOperatorListAEx = this.sortArray(array);
        this.cdr.detectChanges();
    }

    checktypes(array) {
        for (let i = 0; i < array.length; i++) {
            if(this.partner?.filters?.['hideVeranstalter' + array[i].code + 'filter']) {
                array.splice(i, 1);
                i--;
            }
        }

        this.tourOperatorListAll = this.sortArray(array);
        this.cdr.detectChanges();
    }

    initFilterSub(): void {
        this.hotelService.getfilters$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((filter: ParamFilters) => {
            this.selectedList = [];
            if (filter?.tourOperatorList?.length > 0) {
                for (let i = 0; i < filter.tourOperatorList.length; i++) {
                    this.selectedList.push(filter.tourOperatorList[i].code);
                }
            }
            this.cdr.markForCheck();
        });
    }

    selected(op): void {
        let push = true;
        if (this.selectedList.indexOf(op.code) >= 0) {
            push = false;
        }
        this.hotelService.tourOperatorList(op, push);
        this.cdr.markForCheck();
    }
}
